// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarNested_navbar__PFn+-","links":"NavbarNested_links__KMMLl","linksInner":"NavbarNested_linksInner__R6qTx","footer":"NavbarNested_footer__l-u9z"};